import { InvoiceMediaIdentifier } from "./invoicePrintUtils";

export const extractInvoiceMediaIdsFromOrders = (
  orders:
    | Array<{ invoiceInfo?: { invoiceMediaId?: InvoiceMediaIdentifier } }>
    | undefined
): InvoiceMediaIdentifier[] => {
  if (!Array.isArray(orders) || orders.length === 0) {
    return [];
  }

  return orders
    .map((order) => order?.invoiceInfo?.invoiceMediaId)
    .filter(
      (id): id is InvoiceMediaIdentifier => id !== null && id !== undefined
    );
};

export const extractInvoiceMediaIdsFromShipment = (
  shipment: { orders?: any[] } | any
): InvoiceMediaIdentifier[] => {
  const orders = (shipment as any)?.orders;
  return extractInvoiceMediaIdsFromOrders(orders);
};

export const extractInvoiceMediaIdsFromGroup = (
  selectedOrders: string[],
  orderDataMap?: Record<
    string,
    { garaazInvoiceInfo?: { invoiceMediaId?: InvoiceMediaIdentifier } }
  >
): InvoiceMediaIdentifier[] => {
  if (!orderDataMap || selectedOrders.length === 0) {
    return [];
  }

  return selectedOrders
    .map((orderNo) => orderDataMap[orderNo]?.garaazInvoiceInfo?.invoiceMediaId)
    .filter(
      (id): id is InvoiceMediaIdentifier => id !== null && id !== undefined
    );
};
